import Mark from 'mark.js/dist/jquery.mark.min';
import {delay} from './helpers';

const finderContainer = $_pro('#pro-finder-container');
const proFinderIconContainer = $_pro('#pro-finder-icon-container');
const proContent = $_pro('.pro-content');
let proDefaultSectionHtml;
const proFinderFormInput = $_pro('#pro-finder-form-input');
let countFind = 0;
let currentFind = 0;

proFinderIconContainer.on('click', () => {
    if (finderContainer.hasClass('finder-active')) {
        resetFindForm();
    } else {
        finderContainer.addClass('finder-active');
    }
});
$_pro('#pro-finder-form-close').on('click', () => {
    proFinderFormInput.val('');
    finderContainer.removeClass('finder-active');
});

proFinderFormInput.on('keyup', function () {
    doSearch($_pro(this).val());
});

$_pro('#pro-finder-form-close').on('click', () => {
    doSearch('');
});

$_pro('#pro-finder-form-prev').on('click', () => {
    currentFind--;
    findGoTo();
});

$_pro('#pro-finder-form-next').on('click', () => {
    currentFind++;
    findGoTo();
});

function findGoTo() {
    if (countFind > 0) {
        $_pro('mark.pro-finder.pro-finder-current').removeClass('pro-finder-current');
        const findWord = $_pro(`mark.pro-finder:visible:eq(${currentFind})`);
        if (findWord.length !== 0) {
            findWord.addClass('pro-finder-current');
            animation(findWord);
        } else {
            currentFind = 0;
            findGoTo();
        }
    }
}

function doSearch(term) {
    delay(() => {
        const instance = new Mark(document.getElementsByClassName('pro-content'));
        term = term.trim();
        countFind = 0;
        currentFind = 0;
        instance.unmark({
            className: 'pro-finder',
        });

        if (term) {
            const searchRegex = new RegExp(term, 'gim');
            instance.markRegExp(searchRegex, {
                className: 'pro-finder',
            });

            countFind = proContent.find('mark.pro-finder:visible').length;
            if (countFind > 0) {
                proFinderFormInput.parent().removeClass('has-error').addClass('has-success');
                findGoTo();
            } else {
                proFinderFormInput.parent().removeClass('has-success').addClass('has-error');
            }
        } else {
            proFinderFormInput.parent().removeClass('has-success').removeClass('has-error');
        }
    }, 500);
}

function animation(element) {
    $_pro('body, html, #pro-content-abitur').animate({scrollTop: element.offset().top - 200}, 200);
}

function resetFindForm() {
    finderContainer.removeClass('finder-active');
    proFinderFormInput.val('');
    doSearch('');
}

$_pro(document).on('shown.bs.tab', 'a[data-toggle="tab"]', (e) => {
    resetFindForm();
});
